const sortTags = (a: any, b: any) => {
  a = a.name || "";
  b = b.name || "";
  return a.localeCompare(b);
};

export default sortTags;
